import { render, staticRenderFns } from "./SidebarPanelAuction.vue?vue&type=template&id=67612508&"
import script from "./SidebarPanelAuction.vue?vue&type=script&lang=js&"
export * from "./SidebarPanelAuction.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanelAuction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports